import { dateFormatter } from './dateFormatter'

/**
 * Formats the available audit details for a soft-removed record.
 *
 * Returns `undefined` when no audit details are available so callers can omit
 * the tooltip instead of presenting unknown values.
 */
export function removalTooltip({
  removedBy,
  removedDate,
}: {
  removedBy?: string | null
  removedDate?: string | null
}): string | undefined {
  const by = removedBy?.trim()
  const date = removedDate
    ? dateFormatter.shortDatetime(removedDate)
    : undefined

  if (by && date) return `Removed by ${by} on ${date}`
  if (by) return `Removed by ${by}`
  if (date) return `Removed on ${date}`
  return
}
